class MaterialAndShapeDialogComponent extends HTMLElement {

  elasticModulus = 29000000
  momentOfInertia = 50

  configure() {
    document.getElementById('elastic-modulus-input').value = this.elasticModulus
    document.getElementById('moment-of-inertia-input').value = this.momentOfInertia
  }

  publishUpdate() {
    this.configure()
    const event = new CustomEvent('material-and-shape-dialog-update', { detail: this });
    this.dispatchEvent(event)
  }

  onElasticModulusBlur() {
    const value = parseInt(document.getElementById("elastic-modulus-input").value)
    console.log(value)
    if(isNaN(value) || value <= 0) {
      document.getElementById('elastic-modulus-validation').classList.remove('d-none')
      return
    }
    document.getElementById('elastic-modulus-validation').classList.add('d-none') 
    this.elasticModulus = value
    this.publishUpdate()
  }

  onMomentOfInertiaBlur() {
    const value = parseFloat(document.getElementById("moment-of-inertia-input").value)
    if(isNaN(value) || value <= 0) {
      document.getElementById('moment-of-inertia-validation').classList.remove('d-none')
      return
    }
    document.getElementById('moment-of-inertia-validation').classList.add('d-none') 
    this.momentOfInertia = value
    this.publishUpdate()
  }

  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="shape-and-material-dialog" tabindex="-1" role="dialog"
      aria-labelledby="shape-and-material-label" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Shape & Material Properties</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <table class="table">
              <tr class="success">
                <td>Elastic Modulus (<em>E</em>):</td>
                <td>
                  <input style='width:100px;' name='elastic-modulus-input' id='elastic-modulus-input'
                    class='text-center' type='text' value='29000000' /> psi

                  <div  style="width:200px;" id="elastic-modulus-validation" class="alert alert-danger d-none">
                    Please enter a valid Elastic Modulus. e.g. 29000000
                  </div>
                  </td>
              </tr>
              <tr class="success">
                <td>Moment of Inertia (<em>I</em>):</td>
                <td>
                  <input style='width:100px;' name='moment-of-inertia-input' id='moment-of-inertia-input'
                    class='text-center' type='text' value='50' /> in<sup>4</sup>
                  <div  style="width:200px;" id="moment-of-inertia-validation" class="alert alert-danger d-none">
                    Please enter a valid Moment of Inertia. e.g. 50 or 50.0
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
      `

    document.getElementById('elastic-modulus-input').onblur = (() => this.onElasticModulusBlur())
    document.getElementById('moment-of-inertia-input').onblur = (() => this.onMomentOfInertiaBlur())
  }
}

customElements.define('material-and-shape-dialog-component', MaterialAndShapeDialogComponent);
